// import { WardApiClient } from '@/common/services/api/ward-backend/client';
import { BffApiClient } from '@/common/services/api/bffClient';
import type { Transcript, ApiGradesResponse } from '../types/notesTypes';
import { fakeNotesData } from '../data/fakeNotesData';
import { GlobalMockupService } from '@/common/services/mockup';
import { notesEndpoints } from '../endpoints/notesEndpoints';

import { logger } from '@/common/services/config';
class NotesService {
  private static api = BffApiClient.getInstance();

  private static useFakeData = GlobalMockupService.isFeatureMockupEnabled('notes');

  /**
   * Toggle between real API and fake data
   */
  static setUseFakeData(useFake: boolean) {
    this.useFakeData = useFake;
  }

  /**
   * Get current data source status
   */
  static getUseFakeData(): boolean {
    return this.useFakeData;
  }

  /**
   * Get all available transcript periods for the current student
   */
  static async getGrades(): Promise<ApiGradesResponse> {
    if (this.useFakeData) {
      return new Promise((resolve) => {
        setTimeout(() => {
          // Convert fake data to API format
          const transcripts = Object.values(fakeNotesData.transcriptData);
          const gradesFilters = transcripts.map((t) => ({
            code: t.period,
            label: t.period,
          }));
          const academicSemesterCourses = transcripts.map((t) => ({
            code: t.period,
            courses: t.subjects.map((subject) => ({
              courseCode: `COURSE_${subject.id}`,
              courseLabel: subject.label,
              grades: subject.scores.map((score) => ({
                id: score.id,
                aurionId: score.id,
                publicationDate: new Date().toISOString(),
                gradeValue: score.value || 0,
                maxGrade: score.maxGrade || 10,
                isAverage: score.isAverage,
                fullAverage: score.fullAverage,
                examenCode: `EXAM_${score.id}`,
                examenLabel: score.label,
                coefficient: score.coefficient || 1,
                examenType: score.examenType,
                read: !score.new,
              })),
            })),
          }));
          resolve({ gradesFilters, academicSemesterCourses });
        }, 500);
      });
    }

    try {
      const fullUrl = notesEndpoints.getTranscripts;
      const response = await this.api.get<ApiGradesResponse>(fullUrl);
      return response.data;
    } catch (error) {
      logger.warn('NotesService: API not available');
      logger.error('API Error details:', error);
      throw error;
    }
  }
}

export { NotesService };
